module.exports = __webpack_public_path__ + "static/femme-cercle2x-1d86241f2cd4b5f75dff02b8e3b4cf30.png";